import { IoIosCheckmarkCircle } from 'react-icons/io'
import styled from 'styled-components'

const Img = styled.img`
    width: 70%;
    height: 360px;
    object-fit: cover;
`

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    gap: 20px;
`

const NextButton = styled.button`
    width: 120px;
    height: 40px;
    background-color: #31c690;
    color: white;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    &:hover {
        cursor: pointer;
        background-color: #28a57a;
    }
`

const GreenTick = styled(IoIosCheckmarkCircle)`
    color: #31c690;
    width: 18px;
    height: 18px;
`

const ItemWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

const PicWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    vertical-align: top;
`

export default function AssessmentSetup({
    handleNextButtonClick,
}: {
    handleNextButtonClick: (componentName: 'AssessmentProcedure') => void
}) {
    return (
        <Wrapper>
            <PicWrapper>
                <Img src="/images/home/assessment-set-up.png" />
            </PicWrapper>
            <ContentWrapper>
                <h1>Assessment Set Up</h1>
                <ItemWrapper>
                    <GreenTick />
                    <label>
                        {' '}
                        Set up skill assessment station prior to class. 
                    </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label>
                        {' '}
                        Ensure assessment  space is flat, clear, and safe.
                    </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label>
                        {' '}
                        Ensure filming space is free of distractions. 
                    </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label>
                        {' '}
                        Set video recorder / device up to capture the child’s
                        performance of the skill from a side on position.  
                    </label>
                </ItemWrapper>
                <ItemWrapper>
                    <GreenTick />
                    <label>
                        Video must capture the entire performance of the skill,
                        but does not need to track the ball (for catch, kick and
                        throw).{' '}
                    </label>
                </ItemWrapper>
                <NextButton
                    onClick={() => handleNextButtonClick('AssessmentProcedure')}
                >
                    Next
                </NextButton>
            </ContentWrapper>
        </Wrapper>
    )
}
